var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"amplify-image",attrs:{"src":_vm.url},on:{"click":function($event){return _vm.blowUp(_vm.url)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }